"use client";
import {
  AnimatePresence
} from "./chunk-QQ5UXTVS.mjs";
import {
  date_range_picker_field_default
} from "./chunk-73TKHF55.mjs";
import {
  useDateRangePicker
} from "./chunk-CNP6KVM5.mjs";

// src/date-range-picker.tsx
import { useMemo } from "react";
import { cloneElement, isValidElement } from "react";
import { forwardRef } from "@nextui-org/system";
import { Button } from "@nextui-org/button";
import { TimeInput, DateInputGroup } from "@nextui-org/date-input";
import { FreeSoloPopover } from "@nextui-org/popover";
import { RangeCalendar } from "@nextui-org/calendar";
import { CalendarBoldIcon } from "@nextui-org/shared-icons";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function DateRangePicker(props, ref) {
  const {
    state,
    slots,
    endContent,
    selectorIcon,
    showTimeField,
    classNames,
    disableAnimation,
    isCalendarHeaderExpanded,
    getDateInputGroupProps,
    getStartDateInputProps,
    getEndDateInputProps,
    getPopoverProps,
    getSeparatorProps,
    getStartTimeInputProps,
    getEndTimeInputProps,
    getSelectorButtonProps,
    getSelectorIconProps,
    getCalendarProps,
    CalendarTopContent,
    CalendarBottomContent
  } = useDateRangePicker({ ...props, ref });
  const selectorContent = isValidElement(selectorIcon) ? cloneElement(selectorIcon, getSelectorIconProps()) : /* @__PURE__ */ jsx(CalendarBoldIcon, { ...getSelectorIconProps() });
  const calendarBottomContent = useMemo(() => {
    if (isCalendarHeaderExpanded)
      return null;
    return showTimeField ? /* @__PURE__ */ jsxs("div", { className: slots == null ? void 0 : slots.bottomContent({ class: classNames == null ? void 0 : classNames.bottomContent }), children: [
      /* @__PURE__ */ jsxs("div", { className: slots == null ? void 0 : slots.timeInputWrapper({ class: classNames == null ? void 0 : classNames.timeInputWrapper }), children: [
        /* @__PURE__ */ jsx(TimeInput, { ...getStartTimeInputProps() }),
        /* @__PURE__ */ jsx(TimeInput, { ...getEndTimeInputProps() })
      ] }),
      CalendarBottomContent
    ] }) : CalendarBottomContent;
  }, [state, showTimeField, CalendarBottomContent, isCalendarHeaderExpanded]);
  const calendarTopContent = useMemo(() => {
    if (isCalendarHeaderExpanded)
      return null;
    return CalendarTopContent;
  }, [showTimeField, CalendarTopContent, isCalendarHeaderExpanded]);
  const popoverContent = state.isOpen ? /* @__PURE__ */ jsx(FreeSoloPopover, { ...getPopoverProps(), offset: 20, children: /* @__PURE__ */ jsx(
    RangeCalendar,
    {
      ...getCalendarProps(),
      bottomContent: calendarBottomContent,
      topContent: calendarTopContent
    }
  ) }) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      DateInputGroup,
      {
        ...getDateInputGroupProps(),
        endContent: /* @__PURE__ */ jsx(Button, { ...getSelectorButtonProps(), children: endContent || selectorContent }),
        children: [
          /* @__PURE__ */ jsx(date_range_picker_field_default, { ...getStartDateInputProps() }),
          /* @__PURE__ */ jsx("span", { ...getSeparatorProps(), "aria-hidden": "true", role: "separator", children: "-" }),
          /* @__PURE__ */ jsx(date_range_picker_field_default, { ...getEndDateInputProps() })
        ]
      }
    ),
    disableAnimation ? popoverContent : /* @__PURE__ */ jsx(AnimatePresence, { children: popoverContent })
  ] });
}
DateRangePicker.displayName = "NextUI.DateRangePicker";
var date_range_picker_default = forwardRef(DateRangePicker);

export {
  date_range_picker_default
};
